var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.params.isNumber
        ? _c(
            "el-input",
            _vm._b(
              {
                ref: "input",
                attrs: {
                  "filter-chars": _vm.filterChart,
                  "data-code": _vm.params.field || ""
                },
                on: { blur: _vm.onBlur },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              },
              "el-input",
              _vm.params.inputProps,
              false
            )
          )
        : _vm._e(),
      _vm.params.isNumber
        ? _c(
            "el-input",
            _vm._b(
              {
                directives: [
                  {
                    name: "stopNumberMousewheel",
                    rawName: "v-stopNumberMousewheel"
                  }
                ],
                ref: "input",
                staticStyle: { width: "100%" },
                attrs: { type: "number" },
                on: { blur: _vm.onBlur },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              },
              "el-input",
              _vm.params.inputProps,
              false
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }